import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import fetchModuleGroup from '../../actions/ModuleGroupActions';

import { getModuleGroup } from '../../selectors/promotions/SmallTopBanner';

import './SmallTopBanner.less';

class SmallTopBanner extends Component {
  componentDidMount() {
    const { getModules, tag } = this.props;
    if (tag && tag !== '') {
      getModules(tag);
    }
  }

  render() {
    const { moduleGroup, shouldRender } = this.props;
    if (shouldRender && moduleGroup && moduleGroup.moduleViews) {
      return (
        <div className="col-xs-12 col-md-12 banner-promo-module">
          {moduleGroup.moduleViews.map((moduleView, idx) => (
            <a href={moduleView.link_path} rel="noopener noreferrer" key={idx}>
              <span>{moduleView.link_label}</span>
            </a>
          ))}
        </div>
      );
    }
    return null;
  }
}

SmallTopBanner.propTypes = {
  getModules: PropTypes.func.isRequired,
  moduleGroup: PropTypes.shape({}),
  shouldRender: PropTypes.bool.isRequired,
  tag: PropTypes.string,
};

SmallTopBanner.defaultProps = {
  shouldRender: false,
};

const mapStateToProps = (state, props) => ({
  moduleGroup: getModuleGroup(state, props),
});

const mapDispatchToProps = dispatch => ({
  getModules: tag => dispatch(fetchModuleGroup(tag)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SmallTopBanner);



/** WEBPACK FOOTER **
 ** ./src/components/promotions/SmallTopBanner.jsx
 **/